export default "__VITE_ASSET__RddwyEoc__"